import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FileErrorModalComponent } from '../file-error-modal/file-error-modal.component';
import { IconComponent } from '@app/components/shared/icon/icon.component';
import { IconName } from '@app/utils/enums/icon-enum';

@Component({
  selector: 'app-file-export-modal',
  standalone: true,
  imports: [IconComponent, TranslatePipe],
  templateUrl: './file-export-modal.component.html',
  styleUrl: './file-export-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileExportModalComponent {
  private readonly dialogRef = inject(MatDialogRef<FileErrorModalComponent>);

  public readonly IconName = IconName;

  public close(): void {
    this.dialogRef.close();
  }
}
